import { z } from 'zod';
import { PASSWORD_MIN_LENGTH } from '../constants.js';
export const UserStatusEnum = z.enum(['active', 'disabled', 'locked']);
/** User PROFILE item (DynamoDB USER#<id> SK=PROFILE) */
export const UserProfileSchema = z.object({
    id: z.string().uuid(),
    email: z.string().email().toLowerCase(),
    name: z.string().min(1).max(100),
    is_platform_admin: z.boolean(),
    status: UserStatusEnum,
    failed_login_count: z.number().int().nonnegative().default(0),
    locked_until: z.number().int().optional(), // epoch ms
    password_changed_at: z.number().int().optional(),
    must_change_password: z.boolean().default(true),
    last_login_at: z.number().int().optional(),
    last_login_ip: z.string().optional(),
    created_at: z.number().int(),
    created_by_user_id: z.string().uuid().optional(),
});
/** 建立 User 的 input (platform_admin 用) */
export const CreateUserSchema = z.object({
    email: z.string().trim().email().toLowerCase().max(254),
    name: z.string().trim().min(1).max(100),
    initial_password: z.string().min(PASSWORD_MIN_LENGTH).max(128), // 密码不 trim
    is_platform_admin: z.boolean().default(false),
});
/** 更新 User 的 input */
export const UpdateUserSchema = z.object({
    name: z.string().trim().min(1).max(100).optional(),
    status: UserStatusEnum.optional(),
});
//# sourceMappingURL=user.js.map